import React, { memo, useCallback } from 'react';

import { Box, Typography } from '@mui/material';
import { CheckboxCDS } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import PropTypes from 'prop-types';

import { optionDescriptionStyles, optionLabelStyles } from '../../AiQuestionCard.styles';
import { AiQuestionCardTestIds } from '../../AiQuestionCard.testIds';

const QuestionMultiSelectOption = ({ label, description, checked, disabled, onToggle }) => {
  const onChange = useCallback((event, isChecked) => onToggle(label, isChecked), [label, onToggle]);

  return (
    <CheckboxCDS
      dataTestId={`${AiQuestionCardTestIds.MULTI_SELECT_OPTION}.${label}`}
      disabled={disabled}
      label={
        <Box sx={optionLabelStyles}>
          <Typography variant="regular14">{label}</Typography>
          {description ? (
            <Typography sx={optionDescriptionStyles} variant="regular12">
              {description}
            </Typography>
          ) : null}
        </Box>
      }
      value={checked}
      onChange={onChange}
    />
  );
};

QuestionMultiSelectOption.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  description: PropTypes.string,
  disabled: PropTypes.bool,
};

export default memo(QuestionMultiSelectOption);
